export default __webpack_public_path__ + "static/favicon-0d1137e5f9f269a7ba52da719d03338f.ico";